
import { trackPostRoleSubmit } from '~/lib/linkedInTracker'

export default {
  props: {
    slice: { type: Object, required: true },
  },
  head() {
    return {
      script: [
        {
          hid: 'meeting-embed-code',
          src: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
          defer: true,
        },
      ],
    }
  },

  computed: {
    sourceUrl() {
      return this.slice.primary.data_src.url
    },
  },

  mounted() {
    window.addEventListener('message', this.receiveMessage)
  },

  methods: {
    receiveMessage(event) {
      if (event.data.meetingBookSucceeded) {
        trackPostRoleSubmit()
      }
    },
  },
}
